import React from 'react';
import type { ReactFocusLockProps } from 'react-focus-lock';
import ReactFocusLock from 'react-focus-lock/UI';
import { sidecar } from 'use-sidecar';

const FocusLockSidecar = sidecar(
  () => import(/* webpackPrefetch: true */ 'react-focus-lock/sidecar')
);
const LazyFocusLock = ({ children, ...props }: ReactFocusLockProps) => (
  <ReactFocusLock {...props} sideCar={FocusLockSidecar}>
    {children}
  </ReactFocusLock>
);

export default LazyFocusLock;
